import { __t } from '../i18n/t'
import { composeFieldList, describeField, findFieldOnScreen, type FieldOnScreen } from './formErrorsOnScreen'

const ROOT = 'root.serverError'

type LocateField = (path: string) => FieldOnScreen | null

/**
 * O backend devolve no 400 de validação `body.errors = { "<campo>": "<frase pt-BR>" }`.
 * O react-admin já pinta cada campo quando o form recebe `errors`, mas o toast mostrava só
 * "Invalid request payload input", sem dizer qual campo. Aqui monta o texto do toast, uma linha
 * por campo, com o nome que a pessoa vê na tela e a aba onde ele está:
 *   Revise antes de salvar:
 *   • Rua (aba Endereço): Campo obrigatório
 * Campo que não está na tela (o form mandou sem mostrar) sai com o nome técnico; a frase do backend
 * para esse caso já diz para avisar o suporte (pedido ao dev #10).
 */
export const composeServerErrorMessage = (errors: unknown, locate: LocateField = findFieldOnScreen): string | undefined => {
  if (!errors || typeof errors !== 'object') return undefined
  const lines = Object.entries(errors as Record<string, unknown>)
    .filter(([path, reason]) => path !== ROOT && typeof reason === 'string' && reason)
    .map(([path, reason]) => {
      const field = locate(path)
      // A frase vem em pt-BR do backend; é chave do catálogo, então traduz aqui (o toast é texto composto).
      return `${field ? describeField(field) : path}: ${__t(reason as string)}`
    })
  return composeFieldList(lines)
}

/**
 * Põe o resumo em `errors['root.serverError']` e em `error.message`, preservando `error.body`
 * (é ele que o react-admin lê para marcar os campos). Devolve o próprio erro.
 */
export const withServerErrorMessage = <E>(error: E, locate?: LocateField): E => {
  const body = (error as { body?: { errors?: Record<string, unknown> } } | undefined)?.body
  const message = composeServerErrorMessage(body?.errors, locate)
  if (message && body?.errors) {
    body.errors[ROOT] = message
    ;(error as { message: string }).message = message
  }
  return error
}
